import { render, staticRenderFns } from "./add-label.vue?vue&type=template&id=06de5a36&scoped=true"
import script from "./add-label.vue?vue&type=script&lang=js"
export * from "./add-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de5a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06de5a36')) {
      api.createRecord('06de5a36', component.options)
    } else {
      api.reload('06de5a36', component.options)
    }
    module.hot.accept("./add-label.vue?vue&type=template&id=06de5a36&scoped=true", function () {
      api.rerender('06de5a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/transport/runningplan/components/add-label.vue"
export default component.exports